const toRadians = degrees => degrees * (Math.PI / 180)

const calDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371000 // Earth's radius in meters

  const lat1Radians = toRadians(lat1)
  const lon1Radians = toRadians(lon1)
  const lat2Radians = toRadians(lat2)
  const lon2Radians = toRadians(lon2)

  const deltaLon = lon2Radians - lon1Radians

  const distance =
    R *
    Math.acos(
      Math.cos(lat1Radians) * Math.cos(lat2Radians) * Math.cos(deltaLon) +
        Math.sin(lat1Radians) * Math.sin(lat2Radians)
    )

  if (!Number.isNaN(distance)) {
    return distance
  }

  return 0
}

export default calDistance
